import React, { Component } from 'react';
import OwlCarousel from 'react-owl-carousel';
import "./Slider.scss"

class Slider extends Component {
    constructor() {
        super();
        this.state = {
            Selected: {}
        }
    }
    shouldComponentUpdate(props) {
        return false;
    }
    componentDidMount() {
        window.dispatchEvent(new Event("resize"));
        this.props.setOwlRef ? this.props.setOwlRef(this.owl) : null;
    }
    componentWillReceiveProps(newProps) {
        this.setState({
            Selected: newProps.Selected
        })
    }
    render() {
        return (
            <OwlCarousel
                className={`owl-theme`}
                startPosition={0}
                margin={0}
                nav={true}
                navSpeed={600}
                lazyLoad={true}
                dots={false}
                autoWidth={false}
                responsiveClass={true}
                loop={false}
                ref={(owl) => this.owl = owl}
                navText={["", ""]}
                onChanged={this.props.setNavBar ? this.props.setNavBar : (e) => { }}
                navContainerClass="controller"
                navClass={["arrow right", "arrow left"]}
                responsive={this.props.responsive ? this.props.responsive : {
                    0: {
                        items: 1,
                        slideBy: 1,
                        autoWidth: false,
                        rtl: true,
                        nav: false
                    },
                    1024: {
                        items: 1,
                        slideBy: 1,
                        center: false,
                        autoWidth: false,
                        rtl: true,
                        nav: true
                    }
                }}
            >
                {this.props.children}
            </OwlCarousel>
        );
    }
}

export default Slider;



// WEBPACK FOOTER //
// ./src/Components/Helpers/Slider/Slider.jsx